// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2bcebaf7914a8871e3f6","655":"ea4acfbc1f1dfb009817"}[chunkId] + ".js";
};